import Vue from 'vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate'
import store from '@store'
import { getCookie } from '@utils/cookie'
import { faCloudSleet, faTreasureChest } from '@/node_modules/@fortawesome/pro-light-svg-icons/index';
import { it } from 'date-fns/locale';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


var userEmail = ''  // 用以比對公司信箱與個人信箱
/* 大于0 */
extend('positive', value => {
  if (value >= 0) {
    return true
  }
  return '長度錯誤'
});

/* 在字符串中使用占位符，它将自动用您的字段名称替换：
 * _field_	字段名称  name="标题"。
_value_	验证的字段值。
_rule_	触发此消息的规则名称。
 *  */

/* 必填验证 */
extend('require', {
  validate(value) {
    if (value && typeof value === 'object') {
      if (value.length > 0) {
        return true
      }
    } else if (value && typeof value === 'number') {
      return true
    } else if ((value && value.toString()
      .split(' ')
      .join('').length !== 0 && value !== '' && value !== null && value !== undefined && value.indexOf(value) !== -1) || value === true) {
      return true
    }

    return `請填寫'{_field_}'`
  },
  computesRequired: true,
}
);

/* 同意條款 */
extend('agree', {
  validate(value) {
    if (value) {
      return true
    }
    return `請勾選{_field_}`
  },
  computesRequired: true,
}
);


/* 最小长度 */
extend('min', {
  validate(value, args) {
    if (value.length >= args.length) {
      return true;
    }

    return `{_field_}不能小於${args.length}字元`;
  },
  params: ['length']
});

/* 最小长度到最大长度 */
extend('minmax', {
  validate(value, args) {
    const length = value.length;

    if (length >= args.min && length <= args.max) {
      return true;
    }

    return `{_field_}長度必須在{min}-{max}之間`
  },
  /* 获取多个参数 例：rules="minmax:1,6" */
  params: ['min',
    'max']
});

/* 该规则检查指定值是否在定义的集合内
 * rules="one_of:1,2,3,4,5,6,7,8,9"
 *  */
extend('one_of', (value, values) => {
  return values.indexOf(value) !== -1
});

// regex
extend('regex', {
  validate(value, args) {
    const regex = args.regex;
    if (Array.isArray(value)) {
      return value.every(function (val) {
        return this.validate(val, { regex: regex });
      });
    }

    if (regex.test(String(value))) {
      return true
    }

    return `{_field_}格式錯誤`;
  },
  params: [{
    name: 'regex',
    cast: function (value) {
      if (typeof value === 'string') {
        return new RegExp(value);
      }
      return value;
    }
  }]
});

// 電話號碼 09開頭, 必須是數字, 長度為10
extend('phone', {
  validate(value, args) {
    const phoneRegExp = new RegExp(/^09/);
    const numberRegExp = new RegExp(/^[0-9]*$/);

    return phoneRegExp.test(value)
      && numberRegExp.test(value)
      && String(value).length === 10
  },
  message: '請輸入正確的{_field_}格式, 09XXXXXXXX'
});

// 市內電話
extend('tel', {
  validate(value, args) {
    const phoneRegExp = new RegExp(/^0/);
    const numberRegExp = new RegExp(/^[0-9]*$/);

    return phoneRegExp.test(value)
      && numberRegExp.test(value)
  },
  message: '請輸入正確的{_field_}格式, 02XXXXXXXX'
});

// 手機條碼
extend('phonebarcode', {
  validate(value, args) {
    const phonebarcodeRegExp = new RegExp(/^\/[\dA-Z0-9+-\.]{7}$/);

    return phonebarcodeRegExp.test(value)
  },
  message: '請輸入正確的{_field_}格式'
});

// 自然人憑證條碼
extend('cpcbarcode', {
  validate(value, args) {
    const cpcbarcodeRegExp = new RegExp(/[A-Z]{2}[0-9]{14}$/);

    return cpcbarcodeRegExp.test(value)
  },
  message: '請輸入正確的{_field_}格式'
});

// 捐贈碼
extend('lovecode', {
  validate(value, args) {
    const lovecodeRegExp = new RegExp(/^\d{3,7}$/);

    return lovecodeRegExp.test(value)
  },
  message: '請輸入正確的{_field_}格式'
});

// 公司統編
extend('companyid', {
  validate(value, args) {
    const companyidRegExp = new RegExp(/^[0-9]{8}$/);

    return companyidRegExp.test(value)
  },
  message: '請輸入正確的{_field_}格式'
});


// Email
extend('email', {
  validate(value, args) {
    const emailRegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    return emailRegExp.test(value)
  },
  message: '請輸入正確的{_field_}格式'
});

extend('emailComparison', {
  validate(value) {
    if (value === userEmail) return false
    else return true
  },
  message: "不可與公司信箱相同",
})

extend("emailcheck", {
  validate: tryToCheckEmail,
  message: "Email已被註冊",
});

extend("companyemail", {
  // validate(value, args) {
  //   const domain = value.split('@')[1]
  //   return domain === args[0]
  // },
  validate: tryToCheckCompanyEmail,
  // params: ['target'],
  message: '很抱歉，您的信箱與公司不匹配，請確認您的資料'
});
extend("checkDealerVat", {
  validate: tryToCheckDealerVat,
  message: "很抱歉，查無此經銷公司",
});

// 密碼 長度為8-16
extend('confirm', {
  validate(value, args) {

    return value === args.target
  },
  params: ['target'],
  message: '確認密碼與密碼不相同'
});

extend("phonecheck", {
  validate: tryToCheckPhone,
  message: "手機號碼已被註冊",
});

extend('identity', {
  validate(value, args) {
    return value === '1'
  },
  message: '很抱歉，您的統編僅供註冊經銷會員'
})


// 密碼 長度為8-16
extend('password', {
  validate(value, args) {

    return String(value).length >= 8
      && String(value).length <= 16;
  },
  message: '{_field_}長度為8-16字元'
});

// 密碼 長度為8-16
extend('confirm', {
  validate(value, args) {

    return value === args.target
  },
  params: ['target'],
  message: '確認密碼與密碼不相同'
});


// 數字
extend('number', {
  validate(value, args) {
    const strVal = String(value);

    if (/^[0-9]*$/.test(strVal)) {
      return true;
    }

    return `{_field_}為數字`
  },
  params: [
    {
      name: 'length',
      cast: function (value) {
        return Number(value);
      }
    }
  ],
});


// 必須是數字而且長度剛好為length
extend('digits', {
  validate(value, args) {
    const length = args.length;
    if (Array.isArray(value)) {
      return value.every(function (val) {
        return this.validate(val, { length: length });
      });
    }
    const strVal = String(value);

    if (/^[0-9]*$/.test(strVal) && strVal.length === length) {
      return true;
    }

    return `{_field_}為${length}位數字`
  },
  params: [
    {
      name: 'length',
      cast: function (value) {
        return Number(value);
      }
    }
  ],
});


async function tryToCheckEmail(email) {
  try {
    await store.dispatch("auth/validateEmail", { email })
    return true
  } catch (e) {
    return false
  }
}

async function tryToCheckPhone(mobilePhone) {
  try {
    await store.dispatch("auth/validatePhone", { mobilePhoneCode: '+886', mobilePhone })
    return true
  } catch (e) {
    return false
  }
}

function tryToCheckDealerVat(vat) {
  // try {
  //   await store.dispatch('global/checkVat', vat)
  //   return true
  // } catch(e) {
  //   return false
  // }
  return store.dispatch('global/checkVat', vat)
    .then(({ items }) => {
      // console.log(items['category_name'] === '經銷會員')
      return items['category_name'] === '經銷會員' || items['category_name'] === '零壹員工' || items['category_name'] === '一般'
    }).catch(() => {
      return false
    })
}

function tryToCheckCompanyEmail(email) {
  const cookieVat = getCookie('companyVat')
  if (cookieVat.domain.length === 0 && cookieVat.email.length === 0) {
    return true
  }
  const domainArray = []
  for (const [, value] of Object.entries(cookieVat)) {
    value.forEach((item) => {
      if (item.split('').includes('@')) {
        const mail = item.split('@')[1]
        domainArray.push(mail)
      } else {
        domainArray.push(item)
      }
    })
  }
  const companyEmail = email.split('@')[1]
  userEmail = email
  if (domainArray.includes(companyEmail)) return true
  else return false
}